<template>
	<div>
		<a-page-header
			style="border: 1px solid rgb(235, 237, 240);"
			class="mb-3"
			title="Reports"
			@back="() => $router.go(-1)"
		>
		</a-page-header>
		<a-row type="flex">
			<a-col :span="24">
				<div class="card-container">
					<a-card
						type="card"
						defaultActiveKey="posts"
						key="posts"
						class="post-list"
					>
						<a-row :span="12">
							<div
								class="d-flex align-items-center mb-3"
								style="justify-content:space-between;"
							>
								<div
									class="font-weight-bold text-dark font-size-18 text-nowrap pb-2"
								>
									<a-icon type="rise" class="font-size-18 mr-1" />
									{{ reportType }}
								</div>
								<div
									class="font-weight-bold text-dark font-size-18 text-nowrap pb-2"
								>
									<a-dropdown-button class="ml-auto">
										{{ reportType }}
										<a-menu slot="overlay" @click="handleReportType">
											<a-menu-item key="Hashtag Report">
												<a-icon type="line-chart" />Hashtag Report
											</a-menu-item>
											<a-menu-item key="Logo Report">
												<a-icon type="line-chart" />Brand Report
											</a-menu-item>
											<a-menu-item key="Stories Report">
												<a-icon type="line-chart" />Stories Report
											</a-menu-item>
										</a-menu>
									</a-dropdown-button>
								</div>
							</div>
						</a-row>
						<div class="px-3">
							<a-row type="flex">
								<a-col
									:span="24"
									v-if="!loading && reportType === 'Hashtag Report'"
								>
									<hashtag-report
										:categoryA="categoryA"
										:categoryB="categoryB"
										:accounts="accounts"
									/>
								</a-col>
								<a-col
									:span="24"
									v-if="!loading && reportType === 'Logo Report'"
								>
									<logo-report :accounts="accounts" />
								</a-col>
								<a-col
									:span="24"
									v-if="!loading && reportType === 'Stories Report'"
								>
									<stories-report
										:categoryA="categoryA"
										:categoryB="categoryB"
										:accounts="accounts"
									/>
								</a-col>
							</a-row>
						</div>
					</a-card>
				</div>
			</a-col>
		</a-row>
		<a-row type="flex" justify="center">
			<a-col v-if="loading">
				<IsLoading :isLoading="loading" />
			</a-col>
		</a-row>
	</div>
</template>

<script>
import HashtagReport from '../../components/widgets/Detail/HashtagReport'
import LogoReport from '../../components/widgets/Detail/LogoReport'
import StoriesReport from '../../components/widgets/Detail/StoriesReport'
import IsLoading from '../../components/widgets/loading'

import * as ACTIONS from '@/store/actions'
import { mapActions } from 'vuex'

export default {
	components: {
		HashtagReport,
		LogoReport,
		StoriesReport,
		IsLoading,
	},
	data: function() {
		return {
			reportType: 'Hashtag Report',
			categoryA: [],
			categoryB: [],
			accounts: [],
			loading: true,
		}
	},
	created() {
		this.loadCategories().then(res => {
			this.categoryA = res.main
			this.categoryB = res.sub
		})
		this.loadAccounts()
			.then(res => {
				res.map(account => {
					this.accounts.push(account)
				})
			})
			.then(() => {
				this.loading = false
			})
	},
	methods: {
		handleReportType(e) {
			this.reportType = e.key
			this.$emit('reportType', this.reportType)
		},
		...mapActions({
			loadCategories: ACTIONS.CATEGORY.LIST,
			loadAccounts: ACTIONS.DASHBOARD.ACCOUNTS,
		}),
	},
}
</script>
